import {
    UPDATE_FLIPPED,
    UPDATE_COMPLETE,
    UPDATE_SELECTED,
    UPDATE_SCORE,
    UPDATE_CARDS,
    UPDATE_CURRENT,
    UPDATE_PROCESSING,
    UPDATE_COLLECTIONS,
    RESTORE_FLIP_STATE,
} from "./constants";

export const updateCollections = (payload) => ({
    type: UPDATE_COLLECTIONS,
    payload
});

export const updateCards = (payload) => ({
    type: UPDATE_CARDS,
    payload
});

export const updateCurrent = (payload) => ({
    type: UPDATE_CURRENT,
    payload
});

export const updateSelected = (selected, remove) => ({
    type: UPDATE_SELECTED,
    payload: {
        selected,
        remove
    }
});

export const updateFlipped = (flipped, remove) => ({
    type: UPDATE_FLIPPED,
    payload: {
        flipped,
        remove
    }
});

export const updateFlipComplete = (payload) => ({
    type: UPDATE_COMPLETE,
    payload
});

export const updateProcessing = (payload) => ({
    type: UPDATE_PROCESSING,
    payload
});


export const updateFlipScore = (payload) => ({
    type: UPDATE_SCORE,
    payload
});

export const restoreFlipState = (payload) => ({
    type: RESTORE_FLIP_STATE,
    payload
});
